import React from "react";
import { css } from "styled-components";
import PropTypes from "prop-types";
import { Box } from "rebass";

const childrenPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export const ImageRatio = ({ children }) => (
  <Box
    bg="red"
    css={css`
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0;
        width: 100%;
        padding-bottom: 100%;
      }
      & > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: block;
      }
    `}
  >
    {children}
  </Box>
);

ImageRatio.propTypes = {
  ...childrenPropTypes
};
